export const JSON_ONE1 = {
   
  
    "payload": "201705240001|5akU+PET8bFaJZ3uKmuSLfEgIJNpiwkbkBeGFob7XpHYADJE1sMNlim8JPSEonZav5dSzDsW5W+Tu8jbqD6dpQ35kM3WMy",
    "statusCode": "00",
    "message": "SUCCESS"
        }

